export default __webpack_public_path__ + "static/media/walk_punch_kick_jump_walk.642986cc.gif";